/**
 * `5200` — *{notify, message} {someone, receiver}*, and its two legacy ids.
 *
 * monday kept three block ids for the same sentence (`51`, `5100`, `5200`); all three are
 * registered so recipes import 1:1 and a round-trip through `/v2` returns monday's original id,
 * and all three delegate to this one implementation.
 */
import { z } from 'zod';
import { defineAction } from '../block.js';
import { interpolateTokens } from '../tokens.js';
import { receiverSchema } from '../values.js';
import { resolveReceiver, uniqueRecipients } from './receiver.js';
import { tokenContextFor } from './token-context.js';
export const notifyParams = z.object({
    message: z.string().default(''),
    receiver: receiverSchema,
});
const notifyBlock = (id) => defineAction({
    id,
    kind: 'action',
    app: 'monday',
    sentencePartial: '{notify, message} {someone, receiver}',
    paramsSchema: notifyParams,
    executable: true,
    references: (params) => params.receiver.type === 'user' && params.receiver.value !== null && typeof params.receiver.value !== 'object'
        ? [{ kind: 'user', id: String(params.receiver.value) }]
        : [],
    async execute(context, params) {
        const recipients = uniqueRecipients(await resolveReceiver(context, params.receiver));
        const tokens = await tokenContextFor(context, [params.message]);
        const text = interpolateTokens(params.message, tokens);
        if (recipients.length === 0)
            return { recipients: [], text };
        const { delivered } = await context.services.notify({
            boardId: context.boardId,
            itemId: context.itemId,
            userIds: recipients,
            text,
        });
        return { recipients, delivered, text };
    },
});
export const notifyAction = notifyBlock('5200');
/** Same sentence, older ids (`specs/M6-A3` §12). */
export const notifyActionLegacy51 = notifyBlock('51');
export const notifyActionLegacy5100 = notifyBlock('5100');
//# sourceMappingURL=5200.js.map